<div class="alert alert-dismissible alert-danger d-flex">
  <span class="material-icons">report_problem</span>
  <button
    type="button"
    class="btn-close"
    data-bs-dismiss="alert"
    (click)="snackBarRef.dismiss()"
  ></button>
  @if (data && data.length > 0) {
    <div>
      <p class="alert-heading">
        {{ 'notifications.errorAlert.title' | translate }}
      </p>
      <ul>
        @for (error of errors; track error) {
          <li>{{ error }}</li>
        }
      </ul>
    </div>
  }
</div>
